
export default ({ submitType, submitSuccessType, submitErrorType, updateTextType, expandType, resetType }) => {
  const INITIAL_STATE = {
    isSubmitting: false,
    isExpanded: false,
    text: ""
  };

  return (state = INITIAL_STATE, action) => {
    if(action.type == submitSuccessType || action.type == submitErrorType) {
      return {
        ...state,
        isSubmitting: false
      };
    }
    
    switch(action.type) {
      case submitType:
        return {
          ...state,
          isSubmitting: true
        };

      case updateTextType:
        return {
          ...state,
          text: action.text
        };

      case expandType:
        return {
          ...state,
          isExpanded: true
        };

      case resetType:
        return {...INITIAL_STATE};

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/textEditingMaker.js
 **/